import React, { useEffect, useState } from "react";
import "./OnboardingNavCircles.scss";

type Props = {
    numSlides: number;
    currentSlide: number;
};

export const OnboardingNavCircles: React.FC<Props> = (props) => {
    const circles: any[] = [];

    for (let i = 0; i < props.numSlides; ++i) {
        circles.push({});
    }

    const [currentSlide, setCurrentSlide] = useState(props.currentSlide || 0);

    useEffect(() => {
        setCurrentSlide(props.currentSlide);
    }, [props.currentSlide]);

    return (
        <div className={"OnboardingNavCircles"}>
            {circles.map((circle, index) => {
                return <div key={index} className={"circle " + (index === currentSlide ? "current" : null)}></div>;
            })}
        </div>
    );
};
